import React, { useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './defult.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';

const AddInvitations = () => {
  const titleRef = useRef(null);
  const ExpireRef = useRef(null);
  const { SetNotification} = useStateContext();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title: titleRef.current.value,
      expiration: ExpireRef.current.value,
     
    };
    
console.log(payload);
await AxiosClient.post('/invitations', payload, ).then((response) =>{
  SetNotification( ` Invitations code has been Generated successfully ` ,  "success");
    navigate(-1);
  
}).catch((error)=>{
  if (error.response && error.response.data && error.response.data.message) {
    const errorMessage = error.response.data.message;
    SetNotification(errorMessage, 'danger');
  } else {
    SetNotification('An error occurred while creating the invitation.', 'danger');
  }


});

}

  return (
    <div className="m-4">
      <form onSubmit={handleSubmit} className="form-group">
       
       

      <div className="input-group input-group-outline mb-3">
      <input type="text" className="form-control m-2" placeholder="Enter title" ref={titleRef} />

          <select type="text" className="form-control m-2" placeholder="Enter title" ref={ExpireRef} required >
            
            <option value={0}> Select Expired After </option>
            <option value={1}> one day </option>
            <option value={2}> three days </option>
            <option value={3}>one Week </option>
            <option value={4}>three Week </option>
            <option value={5}>one month </option>

            </select>

        </div>
        
      
       

        <button type="submit" className="btn btn-success">
          Generate A new Code
        </button>
      </form>
    </div>
  );
};

export default AddInvitations;